import { useTranslation } from "react-i18next";
import Dropdown from "react-bootstrap/Dropdown";
import { localizedLanguageNames } from "../helpers/dateHelpers";
import { useMemo } from "react";

export const hiddenLocales = new Set(["ase", "ise", "asf", "psr", "bzs", "fsl", "rms", "ssp"]);

export function signLanguageMapper(sign: string): string {
  switch (sign) {
    case "ase":
    case "asf":
      return "en";
    case "ise":
      return "it";
    case "bzs":
      return "pt-BR";
    case "psr":
      return "pt-PT";
    case "fsl":
      return "fr";
    case "rms":
      return "ro";
    case "ssp":
      return "es";
  }

  return sign;
}

export function LanguagePicker(props: { onChange?: (code: string, id: number) => void; enableAll?: boolean }) {
  const { i18n } = useTranslation();

  // we don't show sign languages as options to avoid confusion
  const possibleLocales = useMemo(
    () => localizedLanguageNames(i18n.language).filter((l) => !hiddenLocales.has(l.code)),
    [i18n.language],
  );
  const myLang = signLanguageMapper(i18n.language);
  const myLocale = possibleLocales.find((l) => l.code === myLang);

  const selectLang = async (eventKey: string | null) => {
    if (eventKey) {
      await i18n.changeLanguage(eventKey);
      const locale = possibleLocales.find((l) => l.code === eventKey);
      if (props.onChange) props.onChange(eventKey, locale?.id || 0);
    }
  };

  return (
    <>
      {possibleLocales.map((l) => (
        <Dropdown.Item
          key={l.code}
          eventKey={l.code}
          disabled={!props.enableAll && myLocale?.code === l.code}
          onClick={() => selectLang(l.code)}
        >
          {l.native}
          {l.native !== l.localized && <p className="text-muted hg-small-label ms-1 mb-0 lh-1">{l.localized}</p>}
        </Dropdown.Item>
      ))}
    </>
  );
}
